import { supabase } from '../lib/supabase'
import type { ComercialLookupInput, ComercialLookupItem } from '../types/comercialCadastro'

export const comercialCadastroService = {
  async listActivityTypes(): Promise<ComercialLookupItem[]> {
    const { data, error } = await supabase
      .from('helpdesk_commercial_activity_types')
      .select('*')
      .is('deleted_at', null)
      .order('name')

    if (error) throw error
    return (data ?? []) as ComercialLookupItem[]
  },

  async upsertActivityType(input: ComercialLookupInput): Promise<void> {
    const payload = { name: input.name.trim() }

    if (input.id) {
      const { error } = await supabase
        .from('helpdesk_commercial_activity_types')
        .update(payload)
        .eq('id', input.id)
      if (error) throw error
    } else {
      const { error } = await supabase
        .from('helpdesk_commercial_activity_types')
        .insert(payload)
      if (error) throw error
    }
  },

  async softDeleteActivityType(id: string): Promise<void> {
    const { error } = await supabase
      .from('helpdesk_commercial_activity_types')
      .update({ deleted_at: new Date().toISOString() })
      .eq('id', id)

    if (error) throw error
  },

  async listVisitObjectives(): Promise<ComercialLookupItem[]> {
    const { data, error } = await supabase
      .from('helpdesk_commercial_objective_contact')
      .select('*')
      .is('deleted_at', null)
      .order('name')

    if (error) throw error
    return (data ?? []) as ComercialLookupItem[]
  },

  async upsertVisitObjective(input: ComercialLookupInput): Promise<void> {
    const payload = { name: input.name.trim() }

    if (input.id) {
      const { error } = await supabase
        .from('helpdesk_commercial_objective_contact')
        .update(payload)
        .eq('id', input.id)
      if (error) throw error
    } else {
      const { error } = await supabase
        .from('helpdesk_commercial_objective_contact')
        .insert(payload)
      if (error) throw error
    }
  },

  async softDeleteVisitObjective(id: string): Promise<void> {
    const { error } = await supabase
      .from('helpdesk_commercial_objective_contact')
      .update({ deleted_at: new Date().toISOString() })
      .eq('id', id)

    if (error) throw error
  },

  async listContactReasons(): Promise<ComercialLookupItem[]> {
    const { data, error } = await supabase
      .from('helpdesk_commercial_contact_reasons')
      .select('*')
      .is('deleted_at', null)
      .order('name')

    if (error) throw error
    return (data ?? []) as ComercialLookupItem[]
  },

  async upsertContactReason(input: ComercialLookupInput): Promise<void> {
    const payload = { name: input.name.trim() }

    if (input.id) {
      const { error } = await supabase
        .from('helpdesk_commercial_contact_reasons')
        .update(payload)
        .eq('id', input.id)
      if (error) throw error
    } else {
      const { error } = await supabase
        .from('helpdesk_commercial_contact_reasons')
        .insert(payload)
      if (error) throw error
    }
  },

  async softDeleteContactReason(id: string): Promise<void> {
    const { error } = await supabase
      .from('helpdesk_commercial_contact_reasons')
      .update({ deleted_at: new Date().toISOString() })
      .eq('id', id)

    if (error) throw error
  },
}
